import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import getApiHeaders from 'utils/getApiHeaders'

export interface AuthParams {
  account: string
  accessToken: string
}

export interface TotalRewardToClaim {
  totalToClaim: number
  /** Held back because those licences are listed, moved, or unverifiable. */
  withheldMpro?: number
  withheldLicenses?: number
}

const indexNodeRewardsBaseUrl = (() => {
  const raw =
    import.meta.env.VITE_INDEX_NODE_REWARDS_SERVICE_API_URL ??
    '/api/index-node-rewards/'
  return raw.endsWith('/') ? raw : `${raw}/`
})()

export const indexNodeRewards = createApi({
  reducerPath: 'indexNodeRewards',
  baseQuery: fetchBaseQuery({ baseUrl: indexNodeRewardsBaseUrl }),
  endpoints: (builder) => ({
    getTotalRewardToClaim: builder.query<TotalRewardToClaim, AuthParams>({
      query: (params: AuthParams) => {
        const { account, accessToken } = params
        return {
          url: 'rewards/claimable',
          headers: getApiHeaders({ account, accessToken })
        }
      }
    }),
    addRewardToClaim: builder.mutation<void, AuthParams>({
      query: (params: AuthParams) => {
        const { account, accessToken } = params
        return {
          url: 'rewards/add',
          method: 'POST',
          headers: getApiHeaders({ account, accessToken })
        }
      }
    })
  })
})

export const { useGetTotalRewardToClaimQuery, useLazyGetTotalRewardToClaimQuery, useAddRewardToClaimMutation } =
  indexNodeRewards
